module.exports = __webpack_public_path__ + "static/media/no-data.b059bb39.svg";